import React from "react";


function About() {
return (
<section id="about" className="about">
<h2>About Us</h2>
<p>
Biokare Dental Clinic is a welcoming space where patients feel comfortable.
Our focus is on providing world-class treatments with a personal touch,
ensuring every patient leaves with a brighter, healthier smile.
</p>
</section>
);
}


export default About;